export const MEGA_MENU_SCROLL_BOTTOM_EPSILON = 2
export const MEGA_MENU_SCROLL_IDLE_CONFIRM_DELAY = 500
export const MEGA_MENU_SCROLL_CLOSE_DELAY = 150

/**
 * Resolve the current desktop mega-menu scroll boundary.
 * The 500ms idle confirmation and 150ms close response are handled by Header,
 * while this helper keeps the edge calculation deterministic and testable.
 */
export function resolveMegaMenuScrollBoundary({
  phase = 'scroll',
  scrollTop = 0,
  scrollHeight = 0,
  clientHeight = 0,
  deltaY = 0,
  armed = false,
} = {}) {
  const maxScrollTop = Math.max(Number(scrollHeight) - Number(clientHeight), 0)
  const hasOverflow = maxScrollTop > MEGA_MENU_SCROLL_BOTTOM_EPSILON
  const isAtBottom =
    !hasOverflow || maxScrollTop - Math.max(Number(scrollTop), 0) <= MEGA_MENU_SCROLL_BOTTOM_EPSILON

  if (!isAtBottom) {
    return {
      armed: false,
      isAtBottom: false,
      shouldClose: false,
    }
  }

  if (phase !== 'wheel') {
    return {
      armed: Boolean(armed),
      isAtBottom: true,
      shouldClose: false,
    }
  }

  if (Number(deltaY) < 0) {
    return {
      armed: false,
      isAtBottom: true,
      shouldClose: false,
    }
  }

  if (Number(deltaY) === 0) {
    return {
      armed: Boolean(armed),
      isAtBottom: true,
      shouldClose: false,
    }
  }

  return {
    armed: Boolean(armed),
    isAtBottom: true,
    shouldClose: Boolean(armed),
  }
}
